import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { startLogin } from "@/lib/api";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) startLogin(location.pathname + location.search);
  }, [loading, user, location]);

  if (loading || !user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]" data-testid="auth-loading">
        <div className="h-px w-40 overflow-hidden bg-white/10 thinking-beam" />
      </div>
    );
  }
  return children;
};
